import { mistychnaUkrainaTheme } from "./theme.config.js";
const assetBase = "/assets/quizzes/mistychna-ukraina";
const legends = [
    {
        name: "Лісовик · Господар лісу",
        image: "scene-01-lisovyk.png",
        story: "Мандрівник уже втретє повертався до того самого дуба. Він не помічав, що між деревами за ним спостерігає величезний Лісовик.",
        prompt: "Last night, the traveler ___ the same oak three times.",
        options: ["saw", "see", "seeing", "seen"],
        correctIndex: 0,
        topic: "Past Simple та неправильні дієслова",
        explanation: "Last night указує на завершену подію в минулому. Неправильне дієслово see у Past Simple має форму saw."
    },
    {
        name: "Потерчата · Голоси з болота",
        image: "scene-02-poterchata.png",
        story: "Серед ночі мандрівник почув дитячий плач посеред болота. У тумані спалахнули бліді вогники, а між очеретом з'явилися маленькі постаті. За давніми повір'ями, так могли нагадувати про себе Потерчата — неприкаяні дитячі душі.",
        prompt: "While the traveler ___ along the wooden path, he heard a child crying in the fog.",
        options: ["were walking", "has walked", "was walking", "walking"],
        correctIndex: 2,
        topic: "Past Continuous",
        explanation: "While описує тривалу дію в минулому. The traveler — однина, тому потрібна форма was walking."
    },
    {
        name: "Мавка · Небезпечна красуня",
        image: "scene-03-mavka.png",
        story: "На лісовій галявині незнайомка покликала чоловіка на ім’я. Та старі перекази застерігали: мавки могли заманювати людей дедалі глибше в хащі.",
        prompt: "The mysterious girl appeared ___ the middle of the forest.",
        options: ["at", "in", "on", "to"],
        correctIndex: 1,
        topic: "Прийменники місця",
        explanation: "У значенні «посеред лісу» вживаємо сталий вислів in the middle of."
    },
    {
        name: "Чугайстер · Карпатський велетень",
        image: "scene-04-chuhaister.png",
        story: "Серед карпатських смерек пастух побачив волохатого велетня. Хоч той виглядав страшно, за деякими переказами Чугайстер захищав людей від небезпечних лісових істот.",
        prompt: "In the story, Chuhaister protected travelers from danger. Here, \"protected\" means ___.",
        options: ["frightened", "tricked", "followed", "defended"],
        correctIndex: 3,
        topic: "Синоніми в контексті",
        explanation: "Protected означає «захищав». У цьому контексті найближчий синонім — defended."
    },
    {
        name: "Русалка · Та, що кличе з води",
        image: "scene-05-rusalka.png",
        story: "Увечері над ставком почувся тихий спів. За народними повір’ями, русалки могли з’являтися не лише біля води, а й серед полів та лісів.",
        prompt: "Rusalky appeared not only near rivers ___ in fields and forests.",
        options: ["but also", "because", "unless", "despite"],
        correctIndex: 0,
        topic: "Парні сполучники",
        explanation: "Після not only друга частина парного сполучника — but also: «не лише..., а й...»."
    },
    {
        name: "Перелесник · Вогняний гість",
        image: "scene-06-perelesnyk.png",
        story: "Над самотньою хатою пролетіла вогняна зоря. Незабаром на порозі з’явився незнайомець, напрочуд схожий на людину, яку господиня давно втратила.",
        prompt: "Years ago, on a stormy night, the stranger ___ the form of a lost loved one.",
        options: ["take", "taking", "took", "taken"],
        correctIndex: 2,
        topic: "Past Simple та сталі вирази",
        explanation: "Years ago задає минулий час. У вислові take the form of для Past Simple потрібна форма took."
    },
    {
        name: "Вовкулака · Людина чи звір",
        image: "scene-07-vovkulaka.png",
        story: "Щоночі чоловік зникав із села, а на світанку біля його хати знаходили вовчі сліди. Люди шепотіли, що він став вовкулакою.",
        prompt: "At dawn, the villagers found fresh wolf ___ in the mud.",
        options: ["wings", "tracks", "feathers", "scales"],
        correctIndex: 1,
        topic: "Лексика про природу",
        explanation: "Wolf tracks — це вовчі сліди. Решта слів означають крила, пір’я та луску."
    },
    {
        name: "Мара · Нічний кошмар",
        image: "scene-08-mara.png",
        story: "Чоловік прокинувся від важкого подиху за спиною. Він побачив темну постать біля ліжка, але не міг навіть поворухнутися.",
        prompt: "He tried to run that night, but he ___ move.",
        options: ["can't", "wasn't", "hasn't", "couldn't"],
        correctIndex: 3,
        topic: "Модальні дієслова в минулому",
        explanation: "That night і tried описують минулу подію. Couldn't move означає «не міг поворухнутися»."
    },
    {
        name: "Відьма · Тінь, що живе окремо",
        image: "scene-09-vidma.png",
        story: "Опівночі біля покинутої хати селяни побачили жінку в темній намітці. Вона стояла нерухомо, але її тінь повзла по стіні й поступово набувала подоби звіра. Люди шепотіли: перед ними справжня Відьма.",
        prompt: "The villagers couldn't explain ___ her shadow was moving while she stood completely still.",
        options: ["whose", "which", "why", "whom"],
        correctIndex: 2,
        topic: "Непрямі запитання та питальні слова",
        explanation: "У непрямому запитанні why пояснює причину: селяни не могли зрозуміти, чому рухалася її тінь."
    },
    {
        name: "Упир · Той, хто повернувся",
        image: "scene-10-upyr.png",
        story: "На старому цвинтарі з’явився чоловік, якого поховали багато років тому. Селяни не наважувалися підійти, бо вірили: іноді мертві повертаються.",
        prompt: "The villagers were terrified because the stranger ___ many years before they saw him.",
        options: ["had died", "has died", "dying", "dies"],
        correctIndex: 0,
        topic: "Past Perfect",
        explanation: "Смерть сталася раніше за минулу подію saw. Для попередньої дії вживаємо Past Perfect: had died."
    }
];
const questions = legends.map((legend, index) => {
    const number = String(index + 1).padStart(2, "0");
    const next = index === legends.length - 1 ? "__end__" : `scene_${String(index + 2).padStart(2, "0")}`;
    return {
        id: `scene_${number}`,
        type: "single-choice",
        title: legend.prompt,
        subtitle: legend.story,
        visual: {
            type: "image",
            src: `${assetBase}/${legend.image}`,
            mobileSrc: `${assetBase}/${legend.image.replace(/\.png$/, ".webp")}`,
            mobileObjectPosition: index === 6 ? "90% center" : undefined,
            width: 1536,
            height: 2532,
            alt: legend.name,
            crop: "cover",
            motion: "none"
        },
        answers: legend.options.map((label, answerIndex) => {
            const correct = answerIndex === legend.correctIndex;
            return {
                id: correct ? "correct" : `option_${answerIndex + 1}`,
                label,
                next,
                scores: { grammar: correct ? 1 : 0 },
                tags: correct ? ["correct"] : []
            };
        })
    };
});
export const mistychnaUkrainaQuiz = {
    id: "mistychna-ukraina",
    slug: "mistychna-ukraina",
    version: 1,
    presentation: {
        style: "comic-quest",
        counter: { enabled: true, totalSteps: questions.length },
        questionTransition: "instant",
        skipAnalysis: false,
        ambientAudio: { src: `${assetBase}/forest-ambient.mp3`, volume: 0.16, loop: true },
        comicQuest: {
            logoSrc: "/assets/quizzes/englishdom/logo-white.png",
            totalScenes: questions.length,
            coverCopy: {
                title: "MYSTICAL UKRAINE",
                message: "Ти знаєш, хто живе в українських лісах?",
                description: "Пройди 10 моторошних історій, познайомся з істотами української міфології та перевір свою англійську.",
                benefit: "Наприкінці — твій результат, розбір помилок і персональний план навчання."
            },
            copy: {
                readyChapter: "Фінал · Легенди",
                readyTitle: "Твій розбір готовий",
                readyIntro: "10 легенд позаду. Дізнайся, як ти впорався з англійською.",
                readyRows: ["10 відповідей перевірено", "Результат підраховано", "Розбір помилок підготовлено"],
                accessNote: "Результат, помилки та персональний план відкриються після короткої форми.",
                leadChapter: "Лист із легенд",
                unlockedTitle: "Ти пройшов 10 легенд!",
                unlockedIntro: "Мандрівка крізь українські легенди завершилася. Тепер подивись, що вже добре виходить, а над чим варто попрацювати.",
                captureEyebrow: "Твій маршрут далі",
                captureTitle: "Твій персональний план навчання",
                captureText: "Ми визначили теми, над якими варто попрацювати. Забирай свій безкоштовний персональний план навчання.",
                captureStamp: "MYSTICAL UKRAINE",
                perfectText: "Ти правильно відповів на всі 10 запитань. Усі легенди пройдено!"
            },
            explanations: Object.fromEntries(legends.map((legend, index) => [`scene_${String(index + 1).padStart(2, "0")}`, legend.explanation])),
            topics: Object.fromEntries(legends.map((legend, index) => [`scene_${String(index + 1).padStart(2, "0")}`, legend.topic])),
            showTopicsInResult: false,
            sceneCaptions: Object.fromEntries(legends.map((legend, index) => [`scene_${String(index + 1).padStart(2, "0")}`, legend.name])),
            parchmentSrc: `${assetBase}/parchment.png`,
            analysisBackdrop: { type: "image", src: `${assetBase}/analysis.png`, mobileSrc: `${assetBase}/analysis.webp`, width: 1536, height: 2532, alt: "Рукопис і лампа в нічній хаті", crop: "cover", motion: "none" },
            lockedResultArt: { type: "image", src: `${assetBase}/ready.png`, mobileSrc: `${assetBase}/ready.webp`, width: 1536, height: 2532, alt: "Запечатаний рукопис у старій хаті", crop: "cover", objectPosition: "center 38%", motion: "reveal" },
            leadArt: { type: "image", src: `${assetBase}/lead.png`, mobileSrc: `${assetBase}/lead.webp`, width: 1536, height: 2532, alt: "Запечатаний лист біля різьблених дверей", crop: "cover", objectPosition: "center 45%", motion: "reveal" },
            unlockedResultArt: { type: "image", src: `${assetBase}/result.png`, mobileSrc: `${assetBase}/result.webp`, width: 1536, height: 2532, alt: "Світанок над українським селом", crop: "cover", objectPosition: "center 12%", motion: "reveal" }
        },
        completion: {
            mode: "telegram",
            lockedTitle: "Твій розбір готовий",
            lockedText: "Залиш контакти, щоб відкрити результат, розбір помилок і персональний план навчання.",
            successTitle: "Твій персональний план навчання",
            successText: "Ми визначили теми, над якими варто попрацювати. Забирай свій безкоштовний персональний план навчання.",
            ctaLabel: "Забрати персональний план",
            ctaUrl: "https://t.me/englishdom_ua_bot/?start=qz=quiz__tfm=pp3"
        }
    },
    metadata: { name: "Englishdom", language: "uk", description: "Десять містичних українських легенд для перевірки англійської.", pageTitle: "Mystical Ukraine | Englishdom" },
    startQuestionId: "scene_01",
    start: {
        enabled: true,
        renderer: "native",
        mode: "cta",
        layout: "full-bleed",
        title: "MYSTICAL UKRAINE",
        subtitle: "Ти знаєш, хто живе в українських лісах?",
        cta: { label: "Почати тест", action: "startQuiz" },
        media: { type: "image", src: `${assetBase}/landing.png`, mobileSrc: `${assetBase}/landing.webp`, alt: "Мандрівник іде нічним українським лісом до села" },
        background: { type: "color", value: "#102025" },
        logo: { enabled: false }
    },
    landing: { enabled: false, sections: [] },
    progress: { mode: "linear", capFinalQuestionAt99: true },
    phone: { defaultCountry: "UA", preferredCountries: ["UA", "PL", "CZ", "DE"], searchable: true },
    questions,
    scoring: { categories: ["grammar"], normalizeTo: 100, tieBreaker: ["mistychna_result"] },
    results: [{
            id: "mistychna_result",
            category: "grammar",
            title: "Ти пройшов 10 легенд!",
            description: "Мандрівка крізь українські легенди завершилася. Тепер подивись, що вже добре виходить, а над чим варто попрацювати.",
            preview: "Твій результат і помилки вже пораховані.",
            gatedContent: "Отримай детальний розбір і персональний план навчання."
        }],
    analysis: {
        title: "Перевіряємо, як ти пройшов 10 легенд",
        subtitle: "Зіставляємо твої відповіді та готуємо персональний розбір англійської.",
        display: "stage-cards",
        durationMs: 3000,
        reducedMotionDurationMs: 300,
        steps: [
            { id: "answers", title: "Перевіряємо 10 відповідей" },
            { id: "mistakes", title: "Знаходимо сильні сторони та помилки" },
            { id: "plan", title: "Готуємо персональний план навчання" }
        ],
        checkpoints: [0, 18, 35, 52, 72, 88, 100]
    },
    leadForm: {
        title: "Відкрий свій розбір",
        subtitle: "Залиш контакти — після заповнення форми тобі відкриються результат, розбір помилок і персональний план навчання.",
        placement: "next-step",
        fields: {
            name: { enabled: true, required: true, label: "Ім'я" },
            phone: { enabled: true, required: true, label: "Телефон" },
            email: { enabled: true, required: true, label: "Електронна пошта" }
        },
        privacyConsentRequired: true,
        marketingConsentEnabled: true,
        submitLabel: "Отримати результат і план"
    },
    integrations: { googleSheets: { enabled: true, leadsTab: "mistychna_ukraina_leads", rawTab: "mistychna_ukraina_raw", questionHeaderMode: "question_ids" } },
    uiCopy: {
        back: "Назад",
        progressLabel: "Прогрес",
        resultEyebrow: "Результат квесту",
        resultCta: "Відкрити свій результат",
        privacyConsent: "Погоджуюся з політикою конфіденційності",
        marketingConsent: "Хочу отримувати корисні поради про навчання",
        leadSaved: "Контакти збережено"
    },
    theme: mistychnaUkrainaTheme
};
